'use strict';
/* eslint no-sync: 0 */

import angular from 'angular';

export class LoadingComponent {
  constructor(Auth, $scope) {
    'ngInject';
    var vm = this
  }

}

export default angular.module('directives.loading', [])
  .component('loading', {
    template: require('./loading.html'),
    restrict: 'E',
    bindings: {
        loading: '=',
    },
    controller: LoadingComponent,
    controllerAs: 'vm'
  }).name



// WEBPACK FOOTER //
// ./client/components/loading/loading.component.js